import React from 'react'
import { images } from '../../images'
import { LiteralsService } from '../../services'
import StyledDiv from './styles'

interface IProps {
  // Literal key; the sentence is capitalised and given its full stop here, so the literals need not carry one.
  literal: string
}

/** A short informative line with the "i" icon, under a form's fields: what the next step will do. */
export const InfoNote: React.FC<IProps> = ({ literal }) => {
  const text = LiteralsService.get(literal, true).trim()
  const sentence = /[.!?]$/.test(text) ? text : `${ text }.`

  return (
    <StyledDiv className="info-note">
      { /* The asset is drawn in black; it is used as a mask so the brand colour paints it. */ }
      <i className="icon" style={{ maskImage: `url(${ images.infoOutline })`, WebkitMaskImage: `url(${ images.infoOutline })` }} aria-hidden="true" />
      <p>{ sentence }</p>
    </StyledDiv>
  )
}
